<template>
    <div class="container">
      <div class="signin__card">
        <img
          v-show="shouldShowCompanyLogo() && !isAnonimous"
          :src="logo"
          alt="Company Logo"
          class="signin__card--logo"
        />
        <h2 v-show="isAnonimous">Empresa anônima</h2>
        <h4 class="signin__card--title">Bem vindo, faça login com o seu CPF</h4>
        <button
          class="signin__card--whatsapp"
          v-if="optimizelyIsEnabled()"
          @click="() => (popupActivity = !popupActivity)"
        >
          <div class="mr-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              version="1.1"
              id="Capa_1"
              x="0px"
              y="0px"
              width="18px"
              height="18px"
              viewBox="0 0 30.667 30.667"
              style="enable-background: new 0 0 30.667 30.667"
              xml:space="preserve"
              class=""
            >
              <g>
                <g>
                  <path
                    d="M30.667,14.939c0,8.25-6.74,14.938-15.056,14.938c-2.639,0-5.118-0.675-7.276-1.857L0,30.667l2.717-8.017   
                       c-1.37-2.25-2.159-4.892-2.159-7.712C0.559,6.688,7.297,0,15.613,0C23.928,0.002,30.667,6.689,30.667,14.939z M15.61,2.382   
                       c-6.979,0-12.656,5.634-12.656,12.56c0,2.748,0.896,5.292,2.411,7.362l-1.58,4.663l4.862-1.545c2,1.312,4.393,2.076,6.963,2.076   
                       c6.979,0,12.658-5.633,12.658-12.559C28.27,8.016,22.59,2.382,15.61,2.382z M23.214,18.38c-0.094-0.151-0.34-0.243-0.708-0.427   
                       c-0.367-0.184-2.184-1.069-2.521-1.189c-0.34-0.123-0.586-0.185-0.832,0.182c-0.243,0.367-0.951,1.191-1.168,1.437   
                       c-0.215,0.245-0.43,0.276-0.799,0.095c-0.369-0.186-1.559-0.57-2.969-1.817c-1.097-0.972-1.838-2.169-2.052-2.536   
                       c-0.217-0.366-0.022-0.564,0.161-0.746c0.165-0.165,0.369-0.428,0.554-0.643c0.185-0.213,0.246-0.364,0.369-0.609   
                       c0.121-0.245,0.06-0.458-0.031-0.643c-0.092-0.184-0.829-1.984-1.138-2.717c-0.307-0.732-0.614-0.611-0.83-0.611   
                       c-0.215,0-0.461-0.03-0.707-0.03S9.897,8.215,9.56,8.582s-1.291,1.252-1.291,3.054c0,1.804,1.321,3.543,1.506,3.787   
                       c0.186,0.243,2.554,4.062,6.305,5.528c3.753,1.465,3.753,0.976,4.429,0.914c0.678-0.062,2.184-0.885,2.49-1.739   
                       C23.307,19.268,23.307,18.533,23.214,18.38z"
                    fill="#FFFFFF"
                  />
                </g>
              </g>
            </svg>
          </div>
          Cadastre-se com WhatsApp
        </button>
        <vs-divider v-if="optimizelyIsEnabled()" position="center"> ou </vs-divider>
        <vs-divider position="center"> ou </vs-divider>
        <div class="signin__badge-anchor signin__badge-anchor--google">
          <button
            type="button"
            class="signin__card--submit signin__card--google"
            @click="handleGoogleLogin"
          >
            <span class="signin__card--google-icon">
              <svg viewBox="0 0 24 24" width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
            </span>
            Entrar com Google
          </button>
          <div v-if="shouldShowBadgeOnGoogle" class="signin__last-used-badge">
            {{ badgeText }}
          </div>
        </div>
        <!-- Form de login com CPF -->
        <ValidationObserver
          ref="observer"
          tag="form"
          v-slot="{ invalid }"
          @submit.prevent="handleSignIn()"
        >
          <!-- Campo de CPF com máscara -->
          <div class="signin__badge-anchor signin__badge-anchor--cpf">
            <ValidationProvider name="cpf" rules="required" v-slot="{ errors }">
              <vs-input
                class="signin__card--input"
                icon="assignment_ind"
                type="text"
                v-model="cpf"
                v-mask="'###.###.###-##'"
                label-placeholder="CPF"
                placeholder="Insira seu CPF"
                :danger="errors.length > 0"
                :danger-text="errors[0]"
              />
            </ValidationProvider>
            <div v-if="shouldShowBadgeOnCpf" class="signin__last-used-badge">
              {{ badgeText }}
            </div>
          </div>
  
          <ValidationProvider name="senha" rules="required" v-slot="{ errors }">
            <vs-input
              class="signin__card--input"
              icon="https"
              type="password"
              v-model="password"
              label-placeholder="Senha"
              placeholder="Insira a senha"
              :danger="errors.length > 0"
              :danger-text="errors[0]"
            />
          </ValidationProvider>
  
          <span class="text-danger text-sm">
            {{ api_error }}
          </span>
  
          <div class="signin__card--forgot-password">
            <router-link to="forgot-password"> Esqueceu a sua senha? </router-link>
          </div>
  
          <button
            type="submit"
            :disabled="invalid"
            :style="{ opacity: invalid ? 0.3 : 1 }"
            class="signin__card--submit bg-primary"
          >
            Iniciar candidatura
          </button>
        </ValidationObserver>
  
        <p class="signin__card--account">
          Não tem uma conta ainda?
          <vs-button
            type="flat"
            class="signin__card--account-link p-0"
            @click="handleRedirect"
          >
            Criar uma conta
          </vs-button>
        </p>
  
        <div class="mt-6">
          <hr>
        </div>
  
        <!-- Ajuste do texto para CPF -->
        <p class="signin__card--forgot-password mt-2">
          Esqueceu o CPF?
          <vs-button
            type="flat"
            class="signin__card--forgot-password p-0"
            @click="handleRedirectEmail"
          >
            Faça login com Email
          </vs-button>
        </p>
      </div>
  
      <!-- Popup de condições (permanece igual) -->
      <vs-popup title="" :active.sync="popupActivity">
        <div class="conditions__container">
          <img
            src="@/assets/images/logo/logo.png"
            alt="Recrutei logo"
            class="conditions__logo"
          />
          <p class="conditions__title">
            Atualizamos nossos Termos de uso e Política de privacidade
          </p>
          <p class="conditions__description">
            Entendemos que você está de acordo com os novos termos de privacidade assim que
            clicar em concordo com os novos termos e continuar utilizando a Experiência de
            Talentos. Para consultar os termos, é só clicar nos links:
            <a
              href="https://recrutei.com.br/termos-de-uso"
              target="_blank"
              class="conditions__link"
              >Termos e condições de uso</a
            >
            e
            <a
              href="https://recrutei.com.br/privacidade-e-seguranca"
              target="_blank"
              class="conditions__link"
              >Política de privacidade</a
            >.
          </p>
          <vs-divider position="center"> </vs-divider>
          <ul>
            <li class="checkbox-wrapper">
              <vs-checkbox v-model="policy_and_privacy">
                <span>Concordo com as </span>
              </vs-checkbox>
              <a href="https://recrutei.com.br/privacidade-e-seguranca" target="blank"
                >Políticas de Privacidade</a
              >
              <span v-if="policy_error" class="checkbox-warning"
                >Clique no quadro para declarar que está de acordo com a política de
                privacidade</span
              >
            </li>
            <li class="checkbox-wrapper">
              <vs-checkbox v-model="conditions_terms">
                <span>Concordo com as </span>
              </vs-checkbox>
              <a href="https://recrutei.com.br/termos-de-uso" target="blank"
                >Termos de uso</a
              >
              <span v-if="condition_error" class="checkbox-warning"
                >Clique no quadro para informar que está de acordo com os termos de
                uso</span
              >
            </li>
          </ul>
          <vs-button @click="handleWhatsApp">Continuar com cadastro</vs-button>
        </div>
      </vs-popup>
      <SocialLoginRegistrationModal
        :active.sync="socialRegModalActive"
        :social-token="pendingSocialToken"
        @completed="onSocialGoogleCompleted"
      />
      <SocialLoginLinkAccountModal
        :active.sync="socialLinkModalActive"
        :social-token="pendingSocialToken"
        :user-email="pendingMaskedEmail"
        @completed="onSocialGoogleCompleted"
      />
    </div>
  </template>
  
  <script>
  import { mapState, mapActions } from "vuex";
  import { keys, get } from "lodash";
  import { ValidationProvider, ValidationObserver } from "vee-validate";
  import * as Sentry from "@sentry/vue";
  import { identifyTalent, trackNewApplication, trackEvent } from "@/services/posthog";
  import { loginWithGoogle } from "@/services/socialLogin";
  import { finishSocialTalentSession } from "@/services/finishSocialTalentSession";
  import SocialLoginRegistrationModal from "@/components/form/SocialLoginRegistrationModal.vue";
  import SocialLoginLinkAccountModal from "@/components/form/SocialLoginLinkAccountModal.vue";
  import { persistUtms } from "@/utils/utmStorage";

  // Caso esteja usando a lib v-mask
  import VueMask from "v-mask";
  import Vue from "vue";
  Vue.use(VueMask);
  
  export default {
    name: "sign-in-form",
    components: {
      ValidationProvider,
      ValidationObserver,
      SocialLoginRegistrationModal,
      SocialLoginLinkAccountModal,
    },
    data: () => ({
      isLoading: true,
      condition_error: false,
      conditions_terms: false,
      policy_error: false,
      policy_and_privacy: false,
      popupActivity: false,
      cpf: "",
      password: "",
      api_error: "",
      socialRegModalActive: false,
      socialLinkModalActive: false,
      pendingSocialToken: null,
      pendingMaskedEmail: "",
    }),
    methods: {
      ...mapActions("step", ["updateCurrentStep"]),
      handleRedirect() {
        const { query, params } = this.$router.history.current;
        this.$router.push({
          name: "signup",
          params,
          query,
        });
      },
      handleRedirectEmail() {
        const { query, params } = this.$router.history.current;
        this.$router.push({
          name: "signin",
          params,
          query,
        });
      },
      async onSocialGoogleCompleted(payload) {
        const { utm_source } = this.$router.history.current.query;
        const { vacancy_id: routeVacancy, company_label: routeLabel } =
          this.$router.history.current.params;
        const company =
          this.company ||
          (this.$store.state.company && this.$store.state.company.company) ||
          null;
        const vacancyId =
          payload.vacancy_id != null ? payload.vacancy_id : routeVacancy;
        const companyLabel =
          payload.company_label != null ? payload.company_label : routeLabel;
        this.$vs.loading({ text: "Entrando..." });
        try {
          await finishSocialTalentSession(
            this.$store,
            this.$router,
            this.updateCurrentStep,
            {
              token: payload.token,
              created_account: payload.created_account,
              application_id: payload.application_id,
              vacancy_id: vacancyId,
              company_label: companyLabel,
              company,
              utm_source,
              dashboardRouteName: vacancyId
                ? "step-basic-info"
                : "dashboard-profile-detail",
            }
          );
        } catch (e) {
          this.api_error =
            "Não foi possível concluir o acesso. Tente novamente.";
        } finally {
          this.$vs.loading.close();
        }
      },
      async handleGoogleLogin() {
        this.api_error = "";
        this.$vs.loading({ text: "Abrindo login com Google..." });
        const { vacancy_id, company_label } = this.$router.history.current.params;
        const { utm_source, utm_campaign, utm_medium } = this.$router.history.current.query;

        try {
          const result = await loginWithGoogle({
            company_label: company_label || undefined,
            vacancy_id: vacancy_id || undefined,
            channel: utm_source || undefined,
            utm_campaign: utm_campaign || undefined,
            utm_medium: utm_medium || undefined,
          });

          if (result.action === "needs_registration") {
            this.pendingSocialToken = result.social_token;
            this.$vs.loading.close();
            this.socialRegModalActive = true;
            return;
          }
          if (result.action === "needs_password") {
            this.pendingSocialToken = result.social_token;
            this.pendingMaskedEmail = result.user_email || "";
            this.$vs.loading.close();
            this.socialLinkModalActive = true;
            return;
          }

          const company =
            this.company ||
            (this.$store.state.company && this.$store.state.company.company) ||
            null;
          await finishSocialTalentSession(
            this.$store,
            this.$router,
            this.updateCurrentStep,
            {
              token: result.token,
              created_account: result.created_account,
              application_id: result.application_id,
              vacancy_id,
              company_label,
              company,
              utm_source,
              dashboardRouteName: vacancy_id
                ? "step-basic-info"
                : "dashboard-profile-detail",
            }
          );
          this.$vs.loading.close();
        } catch (err) {
          this.$vs.loading.close();
          const msg =
            err && err.error === "wrong_account_type"
              ? "Área de login somente para o candidato. Faça login com uma conta diferente ou clique  em Criar uma conta."
              : err && err.error === "social_auth_failed"
                ? "Não foi possível concluir o login com Google. Tente novamente."
                : err && err.error === "google_account_mismatch"
                  ? "Esta conta Google não corresponde ao login já vinculado à sua conta."
                  : err && err.error === "social_email_required"
                    ? "Sua conta Google não retornou e-mail. Use outra conta ou cadastre-se com e-mail."
                : err && err.error === "popup_closed"
                  ? err.message
                  : err && err.error === "popup_blocked"
                    ? err.message
                : err && err.message
                  ? err.message
                  : "Login com Google cancelado ou falhou.";
          this.api_error = msg;
        }
      },
      handleWhatsApp() {
        if (this.policy_and_privacy && this.conditions_terms) {
          this.popupActivity = false;
          const { company_label, vacancy_id } = this.$router.history.current.params;
          const { utm_source, clickid, utm_campaign, utm_medium } = this.$router.history.current.query;
          window.open(
            `https://wa.me/553493389648?text=Ol%C3%A1,%20quero%20me%20candidatar%20em:%20https://jobs.recrutei.com.br/${company_label}/vacancy/${vacancy_id}?utm_source=${utm_source}%26utm_medium=${utm_medium}%26utm_campaign=${utm_campaign}`,
            "_blank"
          );
        } else {
          if (!this.policy_and_privacy) this.policy_error = true;
          if (!this.conditions_terms) this.condition_error = true;
        }
        return;
      },
      shouldShowCompanyLogo() {
        return keys(this.company).length > 0;
      },
      optimizelyIsEnabled() {
        if (!this.company) return false;
        return (
          this.company.has_bot && this.$router.history.current.params.vacancy_id !== undefined
        );
      },
      async handleSignIn() {
        const isValid = await this.$refs.observer.validate();
        const { utm_source, clickid, utm_campaign, utm_medium } = this.$router.history.current.query;
        persistUtms(this.$router.history.current.query);
  
        if (!isValid) return;
  
        this.$vs.loading({
          text: "Carregando...",
        });
  
        const params = this.$router.history.current.params;
        let uri = "";
  
        if (params.company_label === "anonima") {
          uri = `/api/v2/talents/anonimo/login/${params.vacancy_id}`;
        } else {
          uri = params.vacancy_id
            ? `/api/v1/talent/${params.company_label}/login/${params.vacancy_id}`
            : `/api/v1/talent/${params.company_label}/login`;
        }
  
        this.$http
          .post(uri, {
            cpf: this.cpf,
            password: this.password,
            channel: utm_source !== "" ? utm_source : null,
            clickid: clickid !== "" ? clickid : null,
            utm_campaign: utm_campaign !== "" ? utm_campaign : null,
            utm_medium: utm_medium !== "" ? utm_medium : null,
          })
          .then(async (response) => {
            this.$vs.loading.close();
            localStorage.setItem("last_login_method", "password");
  
            if (params.company_label === "anonima") {
              // TODO: Retornar o application_id na resposta
              const {
                token,
                data: { talent },
              } = response.data;
  
              this.$store.dispatch("auth/addToken", { token });
              this.$store.dispatch("diversity/addUser", { user: talent.user });
              this.$store.dispatch("diversity/addDiversity", talent);
  
              localStorage.setItem("userToken", token);
  
              // Ajustar se quiser remover referências de email do Sentry
              Sentry.setUser({
                username: talent.user.name,
                // Removendo a informação de email, caso não seja mais usada
              });

              // PostHog identify (anonima) - identificador por email
              identifyTalent(talent.user && talent.user.email, {
                email: talent.user && talent.user.email,
                name: talent.user && talent.user.name,
                last_company_label: params.company_label,
              });
            } else {
              const { company, token, user, talent, application_id } = response.data;
  
              this.$store.dispatch("diversity/addDiversity", talent);
              this.$store.dispatch("auth/addUser", {
                user: {
                  ...user,
                  talent
                }
              });
              this.$store.dispatch("auth/addToken", { token });
              this.$store.dispatch("company/addId", { company });
  
              localStorage.setItem("userToken", token);
              sessionStorage.setItem("@recrutei:talent:application_id", application_id);
  
              // Ajustar se quiser remover referências de email do Sentry
              Sentry.setUser({ 
                username: user.name,
                // Removendo a informação de email, caso não seja mais usada
              });

              // PostHog identify - identificador por email
              identifyTalent(user && user.email, {
                email: user && user.email,
                name: user && user.name,
                last_company_label: params.company_label || (company && company.label),
              });

              // Track new_application (signin flow with application creation)
              if (application_id) {
                const { vacancy_id, company_label } = this.$router.history.current.params;
                trackNewApplication({
                  vacancy_id,
                  company_id: company && company.id,
                  company_name: company && company.name,
                  company_label: company_label || (company && company.label),
                  channel: (utm_source && utm_source !== "") ? utm_source : undefined,
                });
              }
              // Track simple login (sem candidatura)
              const { vacancy_id: vIdSimple } = this.$router.history.current.params;
              if (!vIdSimple || vIdSimple === undefined) {
                trackEvent("logged_account", {
                  channel: (utm_source && utm_source !== "") ? utm_source : undefined,
                });
              }
            }
  
            const { vacancy_id, company_label } = this.$router.history.current.params;
            this.$router.push({
              name: vacancy_id ? "step-basic-info" : "dashboard-profile-detail",
              params: {
                vacancy_id,
                company_label,
              },
            });
  
            // Após login bem-sucedido, atualize o currentStep para 0
            await this.updateCurrentStep({ order: 0 });
          })
          .catch((error) => {
            this.$vs.loading.close();
            const { data, status } = error.response;
  
            if (
              status === 422 &&
              data &&
              data.errors &&
              Array.isArray(data.errors._error_code) &&
              data.errors._error_code.includes("social_password_not_set")
            ) {
              this.api_error =
                'Sua conta foi criada com Google. Clique no botão "Entrar com Google" para fazer o login. Se quiser redefinir sua senha, clique em "Esqueceu a sua senha".';
              return;
            }

            if (status === 307 && data !== undefined && data.hasOwnProperty("message")) {
              this.api_error = data.message;
            }
  
            if (status === 404) {
              this.api_error = "Vaga não encontrada. Verifique a url de candidatura e tente novamente.";
            }

            if (
              status === 422 &&
              data &&
              data.errors &&
              Array.isArray(data.errors.email) &&
              data.errors.email.length
            ) {
              this.api_error = data.errors.email[0];
              return;
            }

            if (status === 422) {
              if (data !== undefined && data.hasOwnProperty("errors")) {
                const first = data.errors[0];
                if (first && first.errors === "The selected cpf is invalid.") {
                  this.api_error = "O CPF selecionado não existe.";
                } else if (first && first.errors) {
                  this.api_error = first.errors;
                }
              } else if (data !== undefined && data.message) {
                this.api_error = data.message;
              }
            }
          });
      },
    },
    computed: {
      ...mapState("company", ["company"]),
  
      logo() {
        const { company } = this.$store.state.company;
        return company.logo_url;
      },
  
      isAnonimous() {
        const label = get(this.$router, "history.current.params.company_label", null);
        return label === "anonima";
      },

    lastLoginMethod() {
      try {
        if (typeof window === "undefined") return null;
        return localStorage.getItem("last_login_method");
      } catch (_) {
        return null;
      }
    },

    shouldShowBadgeOnGoogle() {
      return this.lastLoginMethod === "google";
    },

    shouldShowBadgeOnCpf() {
      return this.lastLoginMethod === "password";
    },

    badgeText() {
      return "último login";
    },
  },
  watch: {
    conditions_terms(value) {
      if (value) this.condition_error = false;
    },
    policy_and_privacy(value) {
      if (value) this.policy_error = false;
    },
  },
    created() {
      if (!this.company) {
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
  }
  
  .signin__card {
    display: flex;
    flex-direction: column;
    padding: 16px;
    max-width: 360px;
    background: #fff;
    position: relative;
  
    h2 {
      text-align: center;
    }
  
    .signin__badge-anchor {
      position: relative;
    }

    .signin__last-used-badge {
      position: absolute;
      top: -10px;
      right: -8px;
      background: #e9f7ef;
      border: 1px solid #1f9d55;
      color: #0b6b3a;
      padding: 6px 10px;
      border-radius: 9999px;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
      z-index: 2;
      pointer-events: none;
      white-space: nowrap;
      font-size: 10px;
      font-weight: 700;
      text-transform: lowercase;
      letter-spacing: 0.15px;
    }

    &--logo {
      max-width: 130px;
      max-height: 150px;
      margin: 0 auto;
      margin-bottom: 5px;
      margin-top: 10px;
      object-fit: contain;
    }
  
    &--whatsapp {
      border: none;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 5px;
      text-decoration: none;
      color: #fff !important;
      cursor: pointer;
      font-weight: 500;
      background-color: #25d366;
      width: 100%;
      padding: 8px;
      margin: 10px 0;
    }
  
    &--title {
      font-size: 18px;
      margin: 20px 0;
    }
  
    &--input {
      width: 100%;
      margin: 20px 0;
    }
  
    &--forgot-password {
      margin: 15px 0;
  
      a {
        font-size: 12px;
      }
    }
  
    &--submit {
      width: 100%;
      display: flex;
      justify-content: center;
      padding: 0.85rem 2.5rem;
      color: white;
      font-size: 16px;
      font-weight: 200;
      border: 0px;
      border-radius: 5px;
      margin-bottom: 20px;
      transition: color 0.5s;

      &:hover {
        color: #fcfcfc;
        cursor: pointer;
      }
    }

    &--google {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      background: #fff;
      color: #3c4043;
      border: 1px solid #dadce0;

      &:hover {
        background: #f8f9fa;
        color: #3c4043;
      }
    }

    &--google-icon {
      display: flex;
      align-items: center;
    }

    &--account {
      font-size: 14px;
  
      a {
        font-weight: 500;
      }
    }
  }
  
  .conditions__container {
    display: flex;
    flex-direction: column;
    padding: 10px;
  
    hr {
      border-color: red;
    }
  }
  
  .conditions__logo {
    width: 80px;
    height: 80px;
    object-fit: contain;
    margin: 0 auto;
  }
  
  .conditions__title {
    text-align: center;
    margin-bottom: 20px;
  }
  
  .conditions__description {
    text-align: center;
    letter-spacing: 0.1px;
  }
  
  .checkbox-wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    width: 100%;
    margin-bottom: 10px;
  
    span {
      font-size: 12px;
    }
  
    a {
      font-size: 12px;
    }
  }
  
  .checkbox-wrapper:nth-of-type(2) {
    margin-bottom: 30px;
  }
  
  .checkbox-warning {
    font-size: 9.1px !important;
    color: #ea5455;
    margin: 10px 0;
  }
  </style>
  